import awsmobile from './aws-exports';

const getEnvironment = () => {
  const hostname = window.location.hostname;
  const isLocalhost = Boolean(
    hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
  );

  if (isLocalhost) {
    return 'localhost';
  }
  if (hostname === 'dev.enterpret.ai') {
    return 'development';
  }
  if (hostname === 'enterpret-showcase.vercel.app') {
    return 'staging';
  }
  if (hostname === 'pre-prod.enterpret.ai') {
    return 'preProd';
  }

  return 'production';
};

const [
  localRedirectSignIn,
  stagingRedirectSignIn,
  developmentRedirectSignIn,
  productionRedirectSignIn,
  preProdRedirectSignIn,
] = awsmobile.oauth.redirectSignIn.split(',');

const [
  localSAMLRedirectSignIn,
  stagingSAMLRedirectSignIn,
  developmentSAMLRedirectSignIn,
  productionSAMLRedirectSignIn,
  preProdSAMLRedirectSignIn,
] = awsmobile.oauth.redirectSAMLSignIn.split(',');

const [
  localRedirectSignOut,
  stagingRedirectSignOut,
  developmentRedirectSignOut,
  productionRedirectSignOut,
  preProdRedirectSignOut,
] = awsmobile.oauth.redirectSignOut.split(',');

const configMap = {
  localhost: {
    redirectSignIn: localRedirectSignIn,
    redirectSAMLSignIn: localSAMLRedirectSignIn,
    redirectSignOut: localRedirectSignOut,
  },
  staging: {
    redirectSignIn: stagingRedirectSignIn,
    redirectSAMLSignIn: stagingSAMLRedirectSignIn,
    redirectSignOut: stagingRedirectSignOut,
  },
  development: {
    redirectSignIn: developmentRedirectSignIn,
    redirectSAMLSignIn: developmentSAMLRedirectSignIn,
    redirectSignOut: developmentRedirectSignOut,
  },
  production: {
    redirectSignIn: productionRedirectSignIn,
    redirectSAMLSignIn: productionSAMLRedirectSignIn,
    redirectSignOut: productionRedirectSignOut,
  },
  preProd: {
    redirectSignIn: preProdRedirectSignIn,
    redirectSAMLSignIn: preProdSAMLRedirectSignIn,
    redirectSignOut: preProdRedirectSignOut,
  },
};

export const getRedirectURI = (isSAMLInRoute = false) => {
  const environment = getEnvironment();
  const config = configMap[environment];

  return {
    redirectSignIn: isSAMLInRoute
      ? config.redirectSAMLSignIn
      : config.redirectSignIn,
    redirectSignOut: config.redirectSignOut,
  };
};

export const getUpdatedAwsConfig = (isSaml, isSAMLInRoute = false) => {
  return {
    ...awsmobile,
    aws_user_pools_web_client_id: isSaml
      ? process.env.REACT_APP_AWS_SAML_WEB_CLIENT_ID
      : process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
    oauth: {
      ...awsmobile.oauth,
      ...getRedirectURI(isSAMLInRoute),
    },
  };
};
